export const setAccommodationFilter = filter => {
  return {
    type: 'SET_ACCOMMODATION_FILTER',
    filter,
  }
}



// WEBPACK FOOTER //
// ./src/actions/index.js